import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api'

const containerStyle = {
    width: '100%',
    height: '600px',
};

const center = {
    lat: 37.033058026551515,
    lng: 22.082333039744107,
}

const GoogleMapComponent = () => {
    const googleKey = process.env.GATSBY_GOOGLE_MAPS_API

    return (
        <LoadScript googleMapsApiKey={googleKey}>
            <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={17}>
                <Marker  position={center} />
            </GoogleMap>
        </LoadScript>
    );
};

export default GoogleMapComponent;
